'use strict'
import { App, Controller } from '../config/app.js'
import { } from '../component/register/practitioner.js'

class RegisterController extends Controller
{
	async index()
	{
		if (Handlebars.helpers.isApexStore())
			await App.Store.fetch('topic', 'NewAccountApplication')
		this.view.render()
	}

    async practitioner()
	{
		return App.Store.fetch('topic', 'RegisterPractitioner')
			.finally(() => this.view.render())
    }
}

export { RegisterController }
